module.exports = __webpack_public_path__ + "img/Jianguang_Lei.949884cb.png";